__turbopack_context__.v({
  "background": "Lightning-module__90u7qq__background",
  "content": "Lightning-module__90u7qq__content",
  "inner": "Lightning-module__90u7qq__inner",
  "root": "Lightning-module__90u7qq__root",
  "strike": "Lightning-module__90u7qq__strike",
  "strikeAnimation": "Lightning-module__90u7qq__strikeAnimation",
  "strikeGlow": "Lightning-module__90u7qq__strikeGlow",
});
